export const buttonVariants = {
  variant: {
    default: "bg-rose-600 text-white hover:bg-rose-700",
    secondary: "bg-warm-200 text-warm-800 hover:bg-warm-300",
    outline: "border border-warm-300 bg-transparent hover:bg-warm-100",
    ghost: "bg-transparent hover:bg-warm-100",
    danger: "bg-red-600 text-white hover:bg-red-700",
    link: "text-rose-600 underline-offset-4 hover:underline",
  },
  size: {
    sm: "h-8 px-3 text-sm",
    md: "h-10 px-4",
    lg: "h-12 px-6 text-lg",
    icon: "h-10 w-10",
  },
};

export const inputVariants = {
  variant: {
    default: "border-warm-300 bg-white focus:border-rose-500 focus:ring-2 focus:ring-rose-200",
    error: "border-red-500 bg-white focus:border-red-500 focus:ring-2 focus:ring-red-200",
    success: "border-green-500 bg-white focus:border-green-500 focus:ring-2 focus:ring-green-200",
  },
  size: {
    sm: "h-8 px-3 text-sm",
    md: "h-10 px-4",
    lg: "h-12 px-6 text-lg",
  },
};

export const badgeVariants = {
  variant: {
    default: "bg-warm-100 text-warm-800",
    secondary: "bg-rose-100 text-rose-800",
    outline: "border border-warm-300 text-warm-700",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    danger: "bg-red-100 text-red-800",
  },
  size: {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-1 text-sm",
    lg: "px-3 py-1.5 text-base",
  },
};

export const cardVariants = {
  variant: {
    default: "bg-white border border-warm-200",
    elevated: "bg-white border border-warm-200 shadow-md",
    interactive: "bg-white border border-warm-200 hover:border-rose-300 hover:shadow-md transition-all",
    metric: "bg-gradient-to-br from-rose-50 to-white border border-rose-100",
    "panel-dark": "bg-slate-blue-800 text-white",
  },
};